<template class="layout-toolbar">
  <v-app-bar app :dense="false">
    <v-spacer />
    <v-spacer />
    <v-spacer />
    <v-spacer />
    <v-spacer />
    <profile />
  </v-app-bar>
</template>
<style scoped>
/* .theme--light.v-app-bar.v-toolbar.v-sheet{
    font-family: "roboto", sans-serif;
    background: linear-gradient(120deg, #556cdc, #128bfc, #18bef1);
} */
.select-type-report {
  width: 150px !important;
}
.btn-align {
  margin-right: 25px;
  font-size: 12px !important;
  text-transform: capitalize;
}
.plus-icon {
  font-size: 12px !important;
}
.v-expansion-panel::before {
  box-shadow: none !important;
}
.align-right {
  text-align: right;
}
.textspacing {
  margin-top: 0px;
}
.company-dropdown {
  height: 40px;
  max-width: 250px;
}
</style>
<script>
import { mapGetters } from "vuex";
// import Breadcrumbs from "../widget/AppBreadcrumbs.vue";
import Profile from "../widget/AppProfile.vue";
// import Notification from "../widget/AppNotification.vue";
import { hasAccess } from "../../config/admin.route.config";
import rules from "../../utils/rules";
// import api from "@/api/api.service";
// import companyapi from "@/api/company.service";
// import EventBus from "../../utils/EventBus";
// import Customer from "@/components/Common/Customer.vue";
// import EventBus from "../utils/EventBus";
export default {
  name: "TheLayoutToolbar",
  components: {
    // Breadcrumbs,
    Profile,
    // Notification,
  },
  data: () => ({
    reportitems: [{ name: "Report" }, { name: "Integration" }],
    // reportvalue: "",
    repValue: "",
    NewReports: {},
    userdialog: false,
    loading: false,
    valid: true,
    details: "",
    rules: rules,
    // companyName: "",
    trackunitToken: "",
    TrackunitTokenError: "",
    name: "",
    email: "",
    phone: "",
    trackunitnumber: "",
    clientId: "",
    clientSecret: "",
    userName: "",
    password: "",
    showclientSecret: false,
    showpassword: false,
    userRole: "",
    isAccess: {
      reportAbug: true,
      reportRequest: true
    },
    openedPanel: null,
    isCustomer: false,
    parentcompaniesList: [],
    companySelected: {},
    defaultCustomer: true,
    disabled: true,
    layouttoolbarKey: 0,
    currentRoute: null,
    isMapRoute: false
  }),
  watch: {
    deep: true,
    immediate: true,
  },
  computed: {
    ...mapGetters([
      "toolbarDense",
      "navbarShow",
      "roles",
      "reportvalue",
      "reportId",
      "ToolsapiToken",
      "companyName"
    ]),
    toggleNavbarIcon() {
      return this.navbarShow
        ? "mdi-format-indent-decrease"
        : "mdi-format-indent-increase";
    }
  },
  created() {},
  mounted() {
    this.userId = this.$store.getters.userId;
    this.isAccess = hasAccess.dashboard[this.roles]
      ? hasAccess.dashboard[this.roles]
      : this.isAccess;
  },
  methods: {
    toggleNavbar() {
      this.$store.dispatch("NavbarToggle");
    }
  }
};
</script>
